<template>
  <PageHeader
    :image="FichadeInscricaoBannerImage"
    ariaLabel="Pessoas correndo"
    :minHeight="421"
    title="Ficha de Inscrição"
    text="Preencha os campos abaixo."
  />
</template>

<script>
import PageHeader from '@/components/PageHeader'
import FichadeInscricaoBannerImage from '@/images/fichadeInscricaoBannerImage.png'

export default {
  name: 'BannerInscrevase',
  data: () => ({
    FichadeInscricaoBannerImage
  }),
  components: {
    PageHeader
  }
}
</script>

